var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 1.89136V5.33348C11.6666 5.80018 11.6666 6.03354 11.7574 6.2118C11.8373 6.3686 11.9648 6.49608 12.1216 6.57598C12.2999 6.66681 12.5332 6.66681 12.9999 6.66681H16.442M13.3333 10.8334H6.66659M13.3333 14.1667H6.66659M8.33325 7.50008H6.66659M11.6666 1.66675H7.33325C5.93312 1.66675 5.23306 1.66675 4.69828 1.93923C4.22787 2.17892 3.84542 2.56137 3.60574 3.03177C3.33325 3.56655 3.33325 4.26662 3.33325 5.66675V14.3334C3.33325 15.7335 3.33325 16.4336 3.60574 16.9684C3.84542 17.4388 4.22787 17.8212 4.69828 18.0609C5.23306 18.3334 5.93312 18.3334 7.33325 18.3334H12.6666C14.0667 18.3334 14.7668 18.3334 15.3016 18.0609C15.772 17.8212 16.1544 17.4388 16.3941 16.9684C16.6666 16.4336 16.6666 15.7335 16.6666 14.3334V6.66675L11.6666 1.66675Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reports-icon.30f544a56b598b5564d65c03f82ae057.svg";
export { ForwardRef as ReactComponent };